/* eslint-disable */
/**
 * 设置Cookie
 * @param {*} name
 * @param {*} value
 */
export function setCookie(name, value) {
  document.cookie = name + '=' + escape(value)
}

/**
 * 获取Cookie
 * @param {*} name
 */
export function getCookie(name) {
  var strcookie = document.cookie
  var arrcookie = strcookie.split('; ')
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split('=')
    if (arr[0] === name) {
      return arr[1]
    }
  }
  return false
}
/**
 * 删除Cookie
 * @param {*} name
 */
export function removeCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
  }
  return false
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 手机号测试
 * @param {*} $poneInput
 */
export function isPhoneAvailable($poneInput) {
  var myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
  if (!myreg.test($poneInput)) {
    return false
  } else {
    return true
  }
}

/**
 * 邮箱验证
 * @param {*} $mail
 */
export function sMailAvailable($mail) {
  var myreg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
  if (!myreg.test($mail)) {
    return false
  } else {
    return true
  }
}

// 格式化日期：yyyy-MM-dd h:m:s
export function dateformat(date, fmt) {
  if (!(fmt)) {
    fmt = 'yyyy-MM-dd hh:mm:ss'
  }
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

// 验证身份证号格式
export function isIdAvailable(idnumber) {
  // eslint-disable-next-line
  let isid15 = /^\d{15}$/
  // eslint-disable-next-line
  let isid18 = /^\d{17}([0-9X])$/
  if (new RegExp(isid15).test(idnumber) || new RegExp(isid18).test(idnumber)) {
    return true
  }
  return false
}

/**
 * 保存下载内容到本地
 * @param  {String} url     
 */
export function downloadExport(url) {
  const link = document.createElement('a')
  const body = document.querySelector('body')

  link.href = url

  // fix Firefox
  link.style.display = 'none'
  body.appendChild(link)
  link.click()
  body.removeChild(link)
}
/**
 * 判断图片宽度是否满足条件
 * @param  {String} url 导出接口地址
 * @param  {Object} params 参数
 */
export function UrlUpdateParams (url, params) {
  var r = url
  for (let key in params) {
    if (r != null && r !== 'undefined' && r !== '') {
      params[key] = encodeURIComponent(params[key])
      var reg = new RegExp('(^|)' + key + '=([^&]*)(|$)')
      var tmp = key + '=' + params[key]
      if (url.match(reg) != null) {
        // eslint-disable-next-line no-eval
        r = url.replace(eval(reg), tmp)
      } else {
        // eslint-disable-next-line no-useless-escape
        if (r.match('[\?]')) {
          r += '&' + tmp
        } else {
          r += '?' + tmp
        }
      }
    }
  }
  return r
}



// WEBPACK FOOTER //
// ./src/util/utils.js